function registerFeaturedCta() {
  // verify that the widget exists to avoid console errors.
  const widget = document.querySelector('.featured-cta-cards')

  if (widget) {
    const nextButtons = document.querySelectorAll('.btn-mobile-next')
    const prevButtons = document.querySelectorAll('.btn-mobile-prev')

    nextButtons.forEach(button => {
      button.addEventListener('click', event => {
        const currentCard = button.parentElement
        const nextCard = currentCard.nextElementSibling

        if (nextCard) {
          currentCard.style.setProperty('visibility', 'hidden')
          nextCard.style.setProperty('visibility', 'visible')
        }
      })
    })

    prevButtons.forEach(button => {
      button.addEventListener('click', event => {
        const currentCard = button.parentElement
        const previousCard = currentCard.previousElementSibling

        if (previousCard) {
          currentCard.style.setProperty('visibility', 'hidden')
          previousCard.style.setProperty('visibility', 'visible')
        }
      })
    })
  }
}


document.addEventListener('DOMContentLoaded', (event) => {
  registerFeaturedCta()
})
